import { Placeholder } from 'rsuite';
import React from 'react';

const RedditTeamLoader = () => (
	<>
		{
			new Array(50).fill(0).map((_, idx) => (
				<div
					key={idx}
					className="flex h-[82px] items-center font-bold border-b border-b-gray-200 text-black"
				>
					<div className="px-[8px] flex-1 min-w-[100px] flex items-center">
						<div className="px-[8px] flex-1 gap-[16px] flex items-center">
							<Placeholder.Graph
								className="!h-[40px] !w-[40px] !min-w-[40px] !rounded-full"
								active
							/>

							<Placeholder.Graph
								className="!h-[24px]"
								active
							/>
						</div>
					</div>
					<div className="px-[8px] w-[250px] flex items-center">
						<div className="px-[8px] flex-1 gap-[16px] flex items-center">
							<Placeholder.Graph
								className="!h-[32px] !w-[32px] !min-w-[32px] !rounded-full"
								active
							/>

							<Placeholder.Graph
								className="!h-[24px]"
								active
							/>
						</div>
					</div>
					<div className="px-[8px] w-[200px] flex items-center">
						<Placeholder.Graph
							className="!h-[24px]"
							active
						/>
					</div>
					<div className="px-[8px] w-[162px] flex items-center">
						<Placeholder.Graph
							active
							className="!h-[32px] !w-[32px] !min-w-[32px] !rounded-full"
						/>
						<Placeholder.Graph
							active
							className="!h-[32px] !w-[32px] !min-w-[32px] !rounded-full ml-[-10px]"
						/>
						<Placeholder.Graph
							active
							className="!h-[32px] !w-[32px] !min-w-[32px] !rounded-full ml-[-10px]"
						/>
						<Placeholder.Graph
							active
							className="!h-[32px] !w-[32px] !min-w-[32px] !rounded-full ml-[-10px]"
						/>
						<Placeholder.Graph
							active
							className="!h-[32px] !w-[32px] !min-w-[32px] !rounded-full ml-[-10px]"
						/>
						<Placeholder.Graph
							active
							className="!h-[32px] !w-[32px] !min-w-[32px] !rounded-full ml-[-10px]"
						/>
					</div>
					<div className="px-[8px] w-[100px] text-right flex items-center justify-end">
						<Placeholder.Graph
							className="!h-[16px] !w-[24px]"
							active
						/>
					</div>
					<div className="w-[70px] flex items-center justify-center">
						<Placeholder.Graph
							className="!h-[16px] !w-[16px]"
							active
						/>
					</div>
				</div>
			))
		}
	</>
);

export default RedditTeamLoader;
